/** @format */

export const GA4_EVENT_KEYS = Object.freeze([
  'page_view',
  'login',
  'logout',
  'registration_start',
  'registration_complete',
  'widget_click',
  'component_interaction',
  'document_download',
  'search',
  'search_result_click',
  'search_no_results'
] as const);

export type Ga4EventKey = (typeof GA4_EVENT_KEYS)[number];

export interface Ga4EventCatalogEntry {
  ga4EventName: string;
  category: string;
  description: string;
}

export const GA4_EVENT_CATALOG: Readonly<Record<Ga4EventKey, Ga4EventCatalogEntry>> = Object.freeze({
  page_view: {
    ga4EventName: 'page_view',
    category: 'navigation',
    description: 'Page view of any page'
  },
  login: {
    ga4EventName: 'login',
    category: 'user',
    description: 'User successfully logs in'
  },
  logout: {
    ga4EventName: 'logout',
    category: 'user',
    description: 'User logs out'
  },
  registration_start: {
    ga4EventName: 'sign_up_start',
    category: 'conversion',
    description: 'User starts registration'
  },
  registration_complete: {
    ga4EventName: 'sign_up',
    category: 'conversion',
    description: 'User completes registration'
  },
  widget_click: {
    ga4EventName: 'select_content',
    category: 'engagement',
    description: 'User clicks widget'
  },
  component_interaction: {
    ga4EventName: 'select_content',
    category: 'engagement',
    description: 'Interaction with UI component'
  },
  document_download: {
    ga4EventName: 'file_download',
    category: 'content',
    description: 'User downloads document'
  },
  search: {
    ga4EventName: 'search',
    category: 'search',
    description: 'User performs search'
  },
  search_result_click: {
    ga4EventName: 'select_content',
    category: 'search',
    description: 'User clicks search result'
  },
  search_no_results: {
    ga4EventName: 'search_no_results',
    category: 'search',
    description: 'Search returned no results'
  }
});

export function isGa4EventKey(eventKey: string): eventKey is Ga4EventKey {
  return Object.prototype.hasOwnProperty.call(GA4_EVENT_CATALOG, eventKey);
}
